<template>
  <pt-previous-video-audit-table class="pt-previous-video-audit-table__withData" ref="table" :request-data="getDataList" :page-size="pageSize"
  :total-number="Number(totalNumber)" :table-data="tableData" :tableLabels="tableLabels" :status="status">
  <slot/>
  </pt-previous-video-audit-table>
</template>

<script>
import PtPreviousVideoAuditTable from './index'
export default {
  name: 'pt-previous-video-audit-table__withData',
  components: {
    'pt-previous-video-audit-table': PtPreviousVideoAuditTable
  },
  data () {
    return {
      pageSize: 20,
      totalNumber: 0,
      tableData: [],
      currentParams: {}
    }
  },
  props: {
    status: {
      type: String,
      required: true
    },
    tableLabels: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    buildFilterParams (page, params = {}) {
      if (Object.keys(params).length) {
        params.pageable['page'] = page
        params.pageable['size'] = this.pageSize
        return params
      } else {
        return {
          status: this.status,
          pageable: { page: page, size: this.pageSize }
        }
      }
    },
    getDataList (page, next) {
      let data = this.buildFilterParams(page, this.currentParams)
      this.$store.dispatch('getVideoList', data).then(res => {
        next(res.data)
        this.tableData = res.data
        this.totalNumber = res.totalNumber
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err)
      })
    },
    // 筛选数据的参数,不传默认为{}
    reload (params = {}) {
      this.currentParams = params
      this.$refs.table.reload()
    }
  }
}
</script>
